import * as React from 'react';

export const CurvedArrow = () => {
    return (
        <svg width="75" height="65" viewBox="0 0 75 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2676_36210)">
                <path
                    d="M8.15355 48.8505C10.0865 50.4742 11.9308 52.0857 14.0659 53.8731C12.632 54.7126 11.2648 54.4773 10.279 53.7982C7.32134 51.761 4.37666 49.6352 1.64805 47.2685C0.0815881 45.9215 0.6062 44.1877 2.55884 43.5107C5.80494 42.336 9.1138 41.3506 12.4356 40.2768C12.6258 40.2129 12.8667 40.1109 12.9932 40.1736C13.512 40.3361 13.9671 40.6252 14.473 40.8762C14.2311 41.2942 14.1405 41.914 13.798 42.0922C12.618 42.7412 11.4132 43.2512 10.2462 43.8116C9.61194 44.1299 8.99059 44.3597 8.36732 45.2216C9.38003 45.4076 10.4306 45.644 11.4433 45.8299C32.5359 48.7624 52.5569 37.6795 61.4952 18.2805C62.6301 15.7734 63.4614 13.1789 64.4699 10.6091C64.8273 9.71022 65.2225 8.86182 65.5799 7.96298C65.808 7.94952 66.023 8.02459 66.2511 8.01113C66.4393 8.57931 66.8427 9.22257 66.7143 9.79189C66.3918 11.6893 66.0693 13.5867 65.481 15.4471C59.6992 33.975 42.4447 47.4751 22.3771 48.9761C18.5385 49.2554 14.6639 48.8522 10.8391 48.727C10.0286 48.7046 9.28173 48.5556 8.48411 48.4447C8.3447 48.4705 8.2302 48.6353 8.15355 48.8505Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2676_36210">
                    <rect
                        width="75.3149"
                        height="24.3048"
                        fill="white"
                        transform="translate(0 45.2057) rotate(-36.8858)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
